<template>
  <ul class="space-y-2">
    <li v-for="comment in comments" :key="comment.uuid">
      <ApprovalRequestLineCommentLine :comment="comment" />
    </li>
  </ul>
</template>

<script>
import ApprovalRequestLineCommentLine from './ApprovalRequestLineCommentLine.vue';

export default {
  name: 'ApprovalRequestLineComments',
  components: {
    ApprovalRequestLineCommentLine,
  },
  props: {
    commentIds: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    comments() {
      return this.commentIds.map(
        (commentId) => this.$store.state.entities.comments.byId[commentId]
      );
    },
  },
};
</script>
